/* tslint:disable */
/* eslint-disable */
/**
 * Appli métier
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: Yoda 1 & 2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface NoteSettings {
  noteId: string
  kiloEuros: boolean
  referenceAmount: NoteSettingsReferenceAmountEnum
  assujettiImpotsSocietes?: boolean
  impotsSurBeneficeComputed: boolean
  prelevementTnsInCr: boolean
  showDemarrage: boolean
  showDetailPret: boolean
  showPercentageCedant: boolean
  showPercentagePrevisionnel: boolean
  showBfrInverse: boolean
  showPreviousPeriod: boolean
  expandedDetailKeys: Array<string>
}

export const NoteSettingsReferenceAmountEnum = {
  NONE: "NONE",
  CHIFFRE_AFFAIRE: "CHIFFRE_AFFAIRE",
  PRODUITS_EXPLOITATION: "PRODUITS_EXPLOITATION"
} as const

export type NoteSettingsReferenceAmountEnum =
  (typeof NoteSettingsReferenceAmountEnum)[keyof typeof NoteSettingsReferenceAmountEnum]
